import axios from "axios";

export function getUnprocessShippingOrderNotification() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/shipping-order/notification-count`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
